import * as dealerSpecialOrders from './specialOrders';
import * as dealerStockOrders from './stockOrders';
import * as dealerEmergingOrders from './emerging';
import * as trackingSchedule from './trackingSchedule';
import * as possDownload from './possDownload';
import * as immobilized from './immobilized';
import * as dealerOrdersTracking from './tracking';
import * as dealerOrdersManagement from './management';
import * as ordersGroupedManagement from './groupedManagement';
import * as lostSalesReportDetail from './lostSalesReport';
import * as etaManagement from './etaManagement';

const reducers = {
  ...dealerSpecialOrders,
  ...dealerStockOrders,
  ...dealerEmergingOrders,
  ...possDownload,
  ...immobilized,
  ...dealerOrdersTracking,
  ...dealerOrdersManagement,
  ...ordersGroupedManagement,
  ...trackingSchedule,
  ...lostSalesReportDetail,
  ...etaManagement,
};

export default reducers;
